// extracted by mini-css-extract-plugin
export var category = "_kq-9";
export var categoryHeader = "_kq-e";
export var container = "_kq-0";
export var group = "_kq-a";
export var groupItems = "_kq-f";
export var groupSeparator = "_kq-j";
export var loading = "_kq-1";
export var noResults = "_kq-3";
export var placeholder = "_kq-2";
export var resultContent = "_kq-5";
export var resultIcon = "_kq-c";
export var resultItem = "_kq-g";
export var resultMeta = "_kq-8";
export var resultSubtitle = "_kq-7";
export var resultSuffix = "_kq-i";
export var resultTitle = "_kq-6";
export var resultsList = "_kq-4";
export var searchGroup = "_kq-d";
export var selected = "_kq-h";
export var subgroup = "_kq-b";